import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { map, take } from 'rxjs/operators';
import { CurrentUser } from 'src/app/core/user.service';
import { AirCarrierHttpClient } from '../flight-log-api/air-carriers/air-carriers-client.service';

@Injectable({ providedIn: 'root' })
export class PrdUserGuard implements CanActivate, CanActivateChild {
  constructor(
    private _user: CurrentUser,
    private _router: Router,
    private _airCarriers: AirCarrierHttpClient,
  ) {}

  public async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const user = this._user.value;

    if (user?.isFlightLogUser && user.isPrdUser) {
      return true;
    }
    if (user?.isFlightLogUser) {
      return true;
    }
    if (user?.isPrdUser) {
      if (user && user.accessibleAirCarriers.length > 0) {
        this.navigateToFirstAirCarrier();
        return false;
      } else {
        const accessError = 'noAccessibleAirCarriers';
        this._router.navigate(['/unauthorized'], {
          queryParams: {
            error: accessError,
          },
        });
        return false;
      }
    }
    this._router.navigate(['/unauthorized']);
    return false;
  }

  public canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this._user?.value?.isPrdUser) {
      return true;
    }
    this._router.navigate(['/unauthorized']);
    return false;
  }

  public async navigateToFirstAirCarrier() {
    const airCarrierAbbreviation = await this._airCarriers
      .getAll()
      .pipe(
        take(1),
        map(
          (airCarriers) =>
            airCarriers.results
              .filter((ac) =>
                this._user.value?.accessibleAirCarriers.find((aac) => aac.id === ac.id),
              )
              .sort((a, b) => a.abbreviation.localeCompare(b.abbreviation))[0].abbreviation,
        ),
      )
      .toPromise();
    return this._router.navigate([`prd/${airCarrierAbbreviation}/pilots`]);
  }
}
